/** Formatted amount for transaction tables/cards. */
export function formatAmountCell(amountLike) {
  const num = Number(amountLike);
  if (!Number.isFinite(num)) return "—";
  return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** USD currency for list summaries and reports (matches Financial Reports totals). */
export function formatCurrencyUsd(amountLike) {
  const num = Number(amountLike || 0);
  return num.toLocaleString(undefined, { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** Non-negative amounts count as income; negative amounts count as expense (absolute value). */
export function summarizeIncomeExpenseRows(rows) {
  let totalIncome = 0;
  let totalExpense = 0;
  (rows || []).forEach((t) => {
    const amount = Number(t?.amount);
    if (!Number.isFinite(amount)) return;
    if (amount >= 0) totalIncome += amount;
    else totalExpense += Math.abs(amount);
  });
  return { totalIncome, totalExpense, netCashFlow: totalIncome - totalExpense };
}
